// extracted by mini-css-extract-plugin
export default {"items":"FlipCards_items__AS39X","item":"FlipCards_item__j0L1Q","itemDivider":"FlipCards_itemDivider__Be27c","buttonsBlock":"FlipCards_buttonsBlock__J3adT"};